import { useSelector } from 'react-redux';
import { getService } from '@mews-commander/legacy-entities/src/ducks/services';
import { ApplicationState } from '@mews-commander/types';
import { Dash } from '@mews-commander/ui';
import { ServiceLink } from './connected/ServiceLink';

interface ServiceLinkProps {
    serviceId: string;
}

export const ConnectedServiceLink = ({ serviceId }: ServiceLinkProps) => {
    const service = useSelector((state: ApplicationState) => getService(state, { id: serviceId }));
    if (!service) return <Dash />;

    return <ServiceLink service={service} />;
};
